import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { expensesAPI } from '../../services/api';
import toast from 'react-hot-toast';
import { useAuth } from '../../context/AuthContext';
import PrintButton from '../../utils/print';
import PrintLetterhead from '../common/PrintLetterhead';
import { fmtMoney } from '../../utils/currency';
const fmt = fmtMoney;
export default function ExpenseList() {
  const { hasPermission } = useAuth(); const navigate = useNavigate();
  const [expenses, setExpenses] = useState([]); const [loading, setLoading] = useState(true);
  const listRef = useRef(null);
  useEffect(() => { expensesAPI.list({}).then(setExpenses).catch(e=>toast.error(e.message)).finally(()=>setLoading(false)); }, []);
  return (
    <div>
      <div className="toolbar"><h2>Expenses</h2>
        <div className="toolbar-right">
          <PrintButton targetRef={listRef} title={`Expenses - ${new Date().toLocaleDateString()}`} />
          {hasPermission('expenses:create') && <button className="btn btn-primary" onClick={()=>navigate('/expenses/new')}>+ New Expense</button>}
        </div>
      </div>
      {loading ? <div className="spinner" style={{margin:'40px auto'}} /> : (
        <div className="card" ref={listRef}><div className="card-body" style={{padding:0}}>
          <PrintLetterhead />
          <table><thead><tr><th>#</th><th>Date</th><th>Category</th><th>Vendor</th><th>Description</th><th className="text-right">Amount</th><th>Status</th></tr></thead>
            <tbody>{expenses.map(e=>(<tr key={e.id}>
              <td className="font-mono">{e.expense_number}</td><td>{e.expense_date}</td><td>{e.category_name||'-'}</td><td>{e.vendor_name||'-'}</td>
              <td>{e.description||'-'}</td><td className="amount">{fmt(e.total)}</td>
              <td><span className={`badge badge-${e.status?.toLowerCase()}`}>{e.status}</span></td>
            </tr>))}
            {expenses.length===0 && <tr><td colSpan={7} className="text-center text-muted" style={{padding:30}}>No expenses</td></tr>}
          </tbody></table>
        </div></div>
      )}
    </div>
  );
}
